import styled, {css} from 'styled-components';

import {breakpoint, colors} from 'theme';

export const ColumnsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    max-width: unset;
    margin-bottom: 40px;
    margin-top: 36px;

    //&:has(> :last-child:nth-child(3)) {
    //    max-width: 900px;
    //}
    //&:has(> :last-child:nth-child(4)) {
    //    max-width: 1170px;
    //}

    @media (min-width: ${breakpoint.tablet}) {
        gap: 40px;
    }
`;

export const Column = styled.div`
    margin-bottom: 16px;
    flex: 1;
    min-width: 250px;
`;

export const ColumnElement = styled.div`
    margin-bottom: 16px;
`;

export const Typography = styled.div<{highlighted?: boolean}>`
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.1px;
    word-wrap: break-word;
    ${(p) =>
        p.highlighted &&
        css`
            background: ${colors.brandLight};
            padding: 6px 10px;
            border-radius: 6px;
            width: fit-content;
        `}
`;

export const Title = styled(Typography)`
    font-weight: 500;
`;

export const HeaderTypography = styled(Typography)`
    font-size: 13px;
    line-height: 14px;
    color: ${colors.textSecondary};
    margin-bottom: 6px;
`;

export const SpinnerContainer = styled.div`
    min-height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
`;
